import { render } from "./oap-tab-item.vue?vue&type=template&id=2b89968f"
import script from "./oap-tab-item.vue?vue&type=script&lang=js"
export * from "./oap-tab-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__